import { TopExposure } from '../../../../../../models/influencer';
import { DateUtils } from '../../../../../utils/date.utils';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../../services/user.service';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { TopExposuresComponent } from '../top-exposures.component';
import { Router } from '@angular/router';
var TopExposureItemComponent = /** @class */ (function () {
    function TopExposureItemComponent(translate, userService, pdfService, router) {
        this.translate = translate;
        this.userService = userService;
        this.pdfService = pdfService;
        this.router = router;
        this.topExposure = new TopExposure();
        this.platformList = [];
    }
    TopExposureItemComponent.prototype.getPlatformIcon = function () {
        var _this = this;
        if (this.topExposure && this.topExposure.platform) {
            return this.topExposure.platform.name;
        }
        if (this.topExposure && this.topExposure.relativepath) {
            var matchedPlatform = this.platformList.filter(function (platform) {
                return _this.topExposure.relativepath.indexOf(platform.description) >= 0;
            })[0];
            return matchedPlatform !== undefined ? matchedPlatform.name : '';
        }
        return '';
    };
    TopExposureItemComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded(TopExposuresComponent.COMPONENT_NAME);
    };
    TopExposureItemComponent.prototype.onLoadedImageError = function () {
        console.log('Top exposure load image fail');
        this.pdfService.updateNumberImageLoaded(TopExposuresComponent.COMPONENT_NAME);
    };
    /**
     * this method is used to format number data in top-exposure section
     * Example:
     * For Reach and Engagement data:
     * 11650 should be formatted 11,650
     * 120 should be formatted 120
     * 1000000 should be formatted 1,000,000
     * For Impact data:
     * 78 should be formatted 78%
     * @param value
     * @returns {string}
     */
    TopExposureItemComponent.prototype.formatExposureNumber = function (value) {
        var formattedNumber = Number(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (this.exposureType === this.translate.instant('INFLUENCER.insight.top_exposure.impact')) {
            return this.translate.instant('common.percent_formatter', { value: formattedNumber });
        }
        else {
            return formattedNumber;
        }
    };
    TopExposureItemComponent.prototype.formatExposureDate = function (date) {
        return DateUtils.formatDate(date);
    };
    Object.defineProperty(TopExposureItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    TopExposureItemComponent.prototype.openPostPage = function () {
        var currentInfluencer = this.userService.getInfluencerInfo();
        // influencer platform version
        if (currentInfluencer) {
            return this.router.navigate(['dashboard', 'post', this.topExposure.urlHash]);
        }
        else {
            return this.router.navigate(['post'], { queryParams: {
                    influencerId: this.topExposure.influencer_id,
                    urlHash: this.topExposure.urlHash,
                    fullUrl: this.topExposure.url,
                    relativePath: this.topExposure.relativepath,
                    activeAccount: this.activeAccount
                } });
        }
    };
    return TopExposureItemComponent;
}());
export { TopExposureItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposures/top-exposure-item/top-exposure-item.component.ts.pre-build-optimizer.js